import { axiosWithAuth } from "@/lib/AxiosClient";

export class Area {
  constructor(id: string, name: string, siteId: string, tenantId: string, description: string | null) {
    this.id = id
    this.name = name
    this.description = description
    this.siteId = siteId
    this.tenantId = tenantId
  }

  id: string
  name: string
  description: string | null
  siteId: string
  tenantId: string
}

export class AreaService {
  private static readonly BASE_PATH = "/api/areas"
  private static instance = axiosWithAuth;

  static async create(action: Area): Promise<Area> {
    const response = await this.instance.post<Area>(`${this.BASE_PATH}`, action);
    return response.data;
  }

  static async getBySiteId(siteId: string): Promise<Area[]> {
    const response = await this.instance.get<Area[]>(`${this.BASE_PATH}/site/${siteId}`);
    return response.data;
  }

  static async getById(actionId: string): Promise<Area> {
    const response = await this.instance.get<Area>(`${this.BASE_PATH}/${actionId}`);
    return response.data;
  }

  static async update(actionId: string, action: Area): Promise<Area> {
    const response = await this.instance.put<Area>(`${this.BASE_PATH}/${actionId}`, action);
    return response.data;
  }

  static async delete(areaId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/${areaId}`);
  }
}